import { useState, useEffect } from 'react';
import axios from 'axios';

const GeoBlock = ({ children }) => {
  const [isAllowed, setIsAllowed] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkLocation = async () => {
      try {
        const response = await axios.get('https://ipapi.co/json/');
        const country = response.data.country_code;
        setIsAllowed(country === 'IN');
      } catch (error) {
        console.error('Error fetching location:', error);
        // In case of error, allow access to prevent blocking legitimate users
        setIsAllowed(true);
      } finally {
        setLoading(false);
      }
    };

    checkLocation();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAllowed) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <h2>Access Restricted</h2>
        <p>This application is only available for users in India.</p>
      </div>
    );
  }

  return children;
};

export default GeoBlock;
